angular.module('ffApp', ['ngResource', 'truncate', 'youtube-embed']);

$(function(){
	$('.icon-play').hover( function(){
		var holder = $(this).closest('.podcast-item');
		holder.toggleClass('is-active');
	});

    FastClick.attach(document.body);
});

function ___( eng, swe )
{
	return currentLanguage == 'sv' ? swe : eng;
}